import moment from "moment";
import React from "react";
import MDatePicker from "react-datepicker";

class Layout1 extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div class="pickerContainer">
                <MDatePicker 
                    dateFormat={this.props.dateFormat}
                    inline
                    useWeekdaysShort={true}
                    shouldCloseOnSelect={false}
                    minDate={this.props.minDate ? moment(this.props.minDate, this.props.dateFormat).toDate() : null}
                    maxDate={this.props.maxDate ? moment(this.props.maxDate, this.props.dateFormat).toDate() : null}
                    selected={this.props.selected ? moment(this.props.selected, this.props.dateFormat).toDate() : null}
                    onChange={this.props.onChange}
                    startDate={this.props.startDate ? moment(this.props.startDate, this.props.dateFormat).toDate() : null}
                    endDate={this.props.endDate ? moment(this.props.endDate, this.props.dateFormat).toDate() : null}
                    selectsStart={this.props.selectsStart ? moment(this.props.selectsStart, this.props.dateFormat).toDate() : null}
                    selectsEnd={this.props.selectsEnd ? moment(this.props.selectsEnd, this.props.dateFormat).toDate() : null}
                />
            </div>
        )
    }
}

export default Layout1;